import { ChangeEvent, useState } from 'react'
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import TextField from '@mui/material/TextField'
import logo from '../../images/logo-wfgps.svg'
import {
  flexItemCenter,
  flexItemColumn,
  loginSignupButton,
  inputFiledStyle,
  loginSignupImageStyle
} from '../../global'
import { makeStyles } from '@mui/styles'
import { appTheme } from '../../theme'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { useMediaQuery } from '@mui/material'
import { login } from '../../services/AuthService'
//import { useAuthState } from '../Auth/AuthProvider'
import classNames from 'classnames'

const useStyles = makeStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: ' rgba(0, 0, 0, 0.2)'
      },
      '&:hover fieldset': {
        borderColor: '#006BD7'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#006BD7'
      }
    }
  },

  buttonDesing: {
    background: '#253D82',
    color: 'white',
    boxShadow: 'none',
    width: '270px !important',
    margin: '14px auto 0!important',
    display: 'flex',
    '&:hover': {
      background: '#253D82'
    }
  },
  heightVh_16px: {
    height: 'auto',
    [appTheme.breakpoints.up('md')]: {
      height: 'calc(100% - 20px)'
    }
  },
  widthVh_150px: {
    width: '100%',
    [appTheme.breakpoints.up('md')]: {
      width: 'calc(100% - 150px)'
    }
  },
  boxWrapper: {
    padding: '15px',
    [appTheme.breakpoints.up('md')]: {
      padding: '0'
    }
  },
  modalWrapper: {
    marginTop: '0',
    [appTheme.breakpoints.down('lg')]: {
      marginTop: '20px !important'
    }
  },
  inputStyle: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',

    width: '100%',
    [appTheme.breakpoints.up('md')]: {
      width: '270px !important'
    },
    [appTheme.breakpoints.down('md')]: {
      minWidth: '270px !important'
    }
  },
  inputBoxStyle: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'column',
    [appTheme.breakpoints.up('md')]: {
      width: '560px',
      display: 'flex'
    },
    '& .css-gre06o-MuiFormLabel-asterisk': {
      color: '#D50000 '
    }
  },
  closeIcon: {
    width: '100px',
    float: 'right',
    margin: '0.5rem',
    position: 'static',
    [appTheme.breakpoints.down('lg')]: {
      right: '1rem',
      margin: '0',
      position: 'absolute',
      top: '1rem'
    }
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderRadius: '8px'
      }
    },
    '& .css-15ubayx-MuiFormLabel-root-MuiInputLabel-root.Mui-focused': {
      color: 'rgba(73, 69, 79, 1)'
    }
  }
})

interface LoginProps {
  loginPage: boolean
  handleSignupOpen: any
  handleLoginOpen: any
  handleForgotPasswordOpen: any
  handleResetPasswordOpen: any
  classList: any
  modelClose: any
}

// var isWebView = true;
var isMobView = false

const Item = styled(Paper)(({ theme }) => ({}))

const emailValidator = (email: string) => {
  if (!email || email === '') {
    return 'Email is required'
  } else if (!new RegExp(/\S+@\S+\.\S+/).test(email)) {
    return 'Incorrect email format'
  }
  return ''
}
const passwordValidator = (password: string) => {
  if (!password || password === '') {
    return 'Password is required'
  }
  // else if (password.length < 8) {
  //   return "Password must have a minimum 8 characters";
  // }
  return ''
}

function Login(props: LoginProps) {
  // isWebView = !useMediaQuery(appTheme.breakpoints.down("md"));
  isMobView = useMediaQuery(appTheme.breakpoints.down('md'))
  const classes = useStyles()

  const [loginState, setLoginState] = useState({
    email: '',
    password: ''
  })
  const [emailError, setEmailError] = useState('')
  const [passwordError, setPasswordError] = useState('')

  const changeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    let name = event.target.name
    let value = event.target.value
    setLoginState({ ...loginState, [name]: value })
    name === 'email' && setEmailError(emailValidator(value))
    name === 'password' && setPasswordError(passwordValidator(value))
  }

  const handleSignupOpen = () => {
    props.handleSignupOpen()
    props.modelClose()
  }

  const handleForgotPasswordOpen = (e: any) => {
    e.preventDefault()
    props.handleForgotPasswordOpen()
    props.modelClose()
  }

  const validateSignup = () => {
    let validate = true
    if (emailValidator(loginState.email) !== '') {
      validate = false
      setEmailError(emailValidator(loginState.email))
    }
    if (passwordValidator(loginState.password) !== '') {
      validate = false
      setPasswordError(passwordValidator(loginState.password))
    }
    return validate
  }

  //const { updateAuthState } = useAuthState()
  const loginUser = async () => {
    if (!validateSignup()) {
      return
    }

    if (emailError === '' && passwordError === '') {
      try {
        const { data } = await login(loginState.email, loginState.password)
        if (data) {
          if (data.login.statusCode === 200) {
            localStorage.setItem('user', JSON.stringify(data.login.data))
            //updateAuthState(true)
            props.modelClose()
            window.location.reload()
          }
          if (data.login.statusCode === 404) {
            setEmailError(data.login.message)
          }
          if (data.login.statusCode === 401) {
            setPasswordError(data.login.message)
          }
        }
      } catch (error) {
        console.log(error)
      }
    }

    // navigate('/');
  }

  const handleKeyPress = (event: { key: string }) => {
    if (event.key === 'Enter') {
      loginUser()
    }
  }

  return (
    <>
      <Box className={classes.boxWrapper} sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          {/* {!isWebView && <CloseRoundedIcon onClick={props.modelClose} className={classes.closeIcon} sx={{fontSize:20, color:'#253D82', fontWeight:200}} /> } */}
          {!isMobView && (
            <Grid color='info' item sm={12} md={3}>
              <Item
                style={flexItemCenter}
                className={classes.heightVh_16px}
                sx={{
                  bgcolor: 'primary.main',
                  p: 1.6,
                  m: 1.2,
                  mt: { sm: 4, md: 1.2 }
                }}
                color='info'
              >
                <img
                  style={loginSignupImageStyle}
                  src={logo}
                  width='100%'
                  alt='Logo'
                  max-width='224px'
                />
              </Item>
            </Grid>
          )}
          <Grid item xs={12} md={9}>
            <Box>
              <CloseRoundedIcon
                onClick={props.modelClose}
                className={classes.closeIcon}
                sx={{ fontSize: 20, color: '#253D82', fontWeight: 200 }}
              />
            </Box>
            <Box sx={{ p: { sm: 2, xs: 4 }, pb: { sm: 4 } }}>
              <Item style={flexItemColumn} className={classes.heightVh_16px}>
                <Typography
                  variant='h6'
                  align='left'
                  color='primary'
                  sx={{ fontWeight: 600 }}
                >
                  Welcome to the ETA Event Scheduler
                </Typography>
                <Typography
                  sx={{ mb: 5 }}
                  variant='body1'
                  align='center'
                  color='primary'
                >
                  Log in to your account below
                </Typography>
                <Grid
                  sx={{
                    pb: 4,
                    display: 'flex',
                    flexDirection: {
                      sm: 'column-reverse',
                      md: 'row',
                      xs: 'column-reverse'
                    }
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    md={12}
                    sx={{
                      // ml: { xs: 2, md: -6 },
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <Typography sx={{ fontSize: 12, fontWeight: 400 }}>
                      Don’t have an account yet?
                    </Typography>
                    <Link
                      href='#'
                      color='secondary'
                      underline='none'
                      onClick={handleSignupOpen}
                      sx={{
                        display: 'inline',
                        ml: 0.5,
                        fontSize: 12,
                        fontWeight: 600
                      }}
                    >
                      Sign up
                    </Link>
                  </Grid>
                </Grid>
                <Box className={classes.inputBoxStyle}>
                  <TextField
                    focused
                    size='small'
                    className={classNames(classes.root, classes.inputStyle)}
                    sx={inputFiledStyle}
                    required
                    id='outlined-required'
                    label='Email'
                    type='email'
                    name='email'
                    value={loginState.email}
                    onChange={changeHandler}
                    InputLabelProps={{ shrink: true }}
                    helperText={emailError}
                    error={!!emailError}
                    onKeyPress={handleKeyPress}
                    classes={{
                      root: classes.textField
                    }}
                  />
                  <TextField
                    size='small'
                    className={classNames(classes.root, classes.inputStyle)}
                    sx={inputFiledStyle}
                    required
                    id='outlined-password-input'
                    label='Password'
                    type='password'
                    name='password'
                    value={loginState.password}
                    onChange={changeHandler}
                    autoComplete='current-password'
                    InputLabelProps={{ shrink: true }}
                    helperText={passwordError}
                    error={!!passwordError}
                    focused={
                      loginState.email.length > 0 && emailError.length > 0
                    }
                    onKeyPress={handleKeyPress}
                    classes={{
                      root: classes.textField
                    }}
                  />
                </Box>
                <Button
                  className={classes.buttonDesing}
                  sx={loginSignupButton}
                  variant='contained'
                  style={{
                    textTransform: 'none',
                    fontSize: 14,
                    fontWeight: 500
                  }}
                  onClick={loginUser}
                >
                  {' '}
                  Log In
                </Button>
                <Button
                  className={classes.buttonDesing}
                  sx={loginSignupButton}
                  variant='outlined'
                  style={{
                    height: 40,
                    textTransform: 'none',
                    fontSize: 14,
                    fontWeight: 500
                  }}
                  onClick={e => handleForgotPasswordOpen(e)}
                >
                  Reset/Forgot Password
                </Button>
                <Box sx={{ display: 'flex', mt: 2 }}>
                  <Typography sx={{ fontSize: 12, fontWeight: 400 }}>
                    Having Issues?
                  </Typography>
                  <Link
                    href='mailto:events@workforcegps.org'
                    color='secondary'
                    underline='none'
                    sx={{
                      display: 'inline',
                      ml: 0.5,
                      fontSize: 12,
                      fontWeight: 600
                    }}
                  >
                    Contact Support
                  </Link>
                </Box>
              </Item>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default Login
